/** Only browser fetch transport failures may display local demo data. */
const isDemoNetworkFailure = (cause: unknown): boolean =>
  cause instanceof TypeError
  && /^(Failed to fetch|NetworkError when attempting to fetch resource\.?|Load failed)$/i.test(cause.message);

export default isDemoNetworkFailure;
